import { Injectable } from '@angular/core';
import { ChannelEligibilityRule, ChannelPayload } from './rules/channel-eligibility.rule';
import { ConfiguracionCanal, Store } from '@/core/models';
import { JuvoTrackSession } from './interfaces';
import { ChannelPayInStoreRule } from './rules/channel-pay-in-store.rule';
import { ChannelConfigurationRule } from './rules/channel-configuration.rule';

@Injectable({ providedIn: 'root' })
export class ChannelProcessorService {

  public process(data: JuvoTrackSession | null, store: Store | null): ChannelPayload | null {
    const canConnect = ChannelEligibilityRule.isEligible(data, store);
    
    if (!canConnect)
      return null;

    const [channel] = data as JuvoTrackSession;
    
    return {
      localCanalId: channel.idLocalCanal as string,
      token: store!.apiKey,
    };
  }

  isPayInStore(context: ConfiguracionCanal | null): boolean {
    const canPayInStore = ChannelPayInStoreRule.validate(context);

    if (!canPayInStore) return false;

    return true;
  }

  processChannelTheme(context: ConfiguracionCanal | null): string | null {
    return ChannelConfigurationRule.getPrimaryColor(context); 
  }
}